<div class="bg-[#491176] min-h-screen">
    <portals-navbar></portals-navbar>
    <div class="px-3 pb-20" style="padding-top: 60px">
        <h1 class="text-center font-bold text-[#fbd354] title">FREQUENTLY ASKED QUESTIONS</h1>
        <div class="my-10 max-w-[1256px] mx-auto space-y-4 lg:space-y-6" style="margin-top: 60px">
            <div *ngFor="let item of faq; let index = index" class="item bg-[#6d438f] shadow-md rounded-md px-4 py-8">
                <div class="flex items-center cursor-pointer" (click)="toggleFaq(index)">
                    <span [ngClass]="{ 'rotate-180': faqSelected === index }" class="transition-transform duration-300">
                        <svg fill="none" height="24" shape-rendering="geometricPrecision" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" viewBox="0 0 24 24" width="24">
                            <path d="M6 9l6 6 6-6"></path>
                        </svg>
                    </span>
                    <div class="ml-3 md:ml-4 lg:ml-6 md:text-lg text-[#fbd354] font-roboto text-[36px]" style="line-height: 42px">
                        <span>{{ item.question }}</span>
                    </div>
                </div>
                <div [ngStyle]="{ 'max-height': faqSelected === index ? getMaxHeight(index) + 'px' : '0' }" class="faq-content relative overflow-hidden transition-all duration-700">
                    <span style="display: block; height: 5px"></span>
                    <div class="ml-8 md:ml-10 pl-3 md:pl-4 lg:pl-6 py-2 space-y-3 atag overflow-y-auto">
                        <p *ngFor="let ans of item.answer" [innerHTML]="sanitizeHtml(ans)"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <portals-footer></portals-footer>
</div>
